// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"05dc9d44","826":"9fc2aa89","966":"05dc9d44"}[chunkId] + ".chunk.css";
};